import { createSlice } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { LocalCache } from '../libreria/LocalCache';

export const unidadesSlice = createSlice({
  name: 'unidades',
  initialState: {
    page: -1,
    count: 0,
    rows: []
  },
  reducers: {
    setUnidades: (state, action) => {
      state.page = action.payload.page;
      state.count = action.payload.count;
      state.rows = action.payload.rows;
    }
  }
});

export const { setUnidades } = unidadesSlice.actions;

// Action Creators
export const getUnidades = (comunidadId, page, size) => async (dispatch, getState) => {
  let offset = page * size;
  let item = LocalCache.get(`KEY:unidades&comunidad=${comunidadId}&offset=${offset}`);
  if (item) {
    dispatch(setUnidades(item));
  } else {
    try {
      const response = await API.get('ePlat', `/unidades-extradata?comunidad=${comunidadId}&offset=${offset}&size=${size}`);
      let unidades = { page: response.count > 0 ? page : -1, count: response.count, rows: response.rows };
      dispatch(setUnidades(unidades));
      LocalCache.put(`KEY:unidades&comunidad=${comunidadId}&offset=${offset}`, unidades);
    } catch (error) {
      console.log('DVD: ERROR Llamada a getUnidades()', error);
    }
  }
};

export default unidadesSlice.reducer;
